import styled from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const HeadlineContent = styled.h2`
    ${FONT_PROPERTIES}
    margin-bottom: 2%;
`;

export const SessionSummaryContent = styled.li`
    margin-top: 4px;
    ${FONT_PROPERTIES};
`;

export const SessionsSummaryWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    max-height: 320px;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.palette.grayscale.gray10} ${({ theme }) => theme.palette.grayscale.white};

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.palette.grayscale.gray10};
        border-radius: 5px 5px;
    }
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS};
`;

export const SessionsSummaryCalendar = styled.div`
    width: 50%;
    display: flex;
    justify-content: space-between;
`;

export const SessionsCalendarHeadLineWrapper = styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 1%;
`;

export const SessionsCalendarLogoWrapper = styled.div`
    width: 50%;
`;

export const SessionInformation = styled.div`
    margin-top: 1%;
    ${FONT_PROPERTIES}
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS};
`;

export const SessionContent = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    padding-bottom: 16px;
`;
